export default __webpack_public_path__ + "static/media/Helm of the Crimson Fort.f16ec54b.jpg";